import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17.03 5 3 5.01v13.98l14.03.01L22 12l-4.97-7z"
}), 'LabelSharp');